import { useContext } from "react";
import { AppContext } from "../contexts/AppContext";
import successImage from "../img/success-img.png";
import { useNavigate } from "react-router-dom";
const ResetPasswordSuccess = () => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const successCompleteHandler = () => {
    appContext.updateModalState();
    appContext.updateLoaderState(true);
    setTimeout(() => {
      localStorage.removeItem("resetPasswordConfirm");
      localStorage.removeItem("userId");
      appContext.updateLoaderState(false);
      navigate("login", { replace: true, relative: "route" });
    }, 200);
  };
  return (
    <div className="modal-body p-5">
      <div className="row">
        <div className="col-md-2"></div>
        <div className="col-md-8">
          <img src={successImage} className="img-fluid" />
        </div>
        <div className="col-md-2"></div>
      </div>
      <p className="text-center code-txt">
        Your password has been successfully changed
      </p>
      <div className="mb-3 mt-4">
        <div className="row">
          <div className="col-md-1"></div>
          <div className="col-md-10 text-center">
            <button
              type="button"
              onClick={successCompleteHandler}
              className="btn btn-primary sign-btn  mt-5"
              disabled={appContext.loaderState}
            >
              Continue
            </button>
          </div>
          <div className="col-md-1"></div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordSuccess;
